// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__VdhEt","productName":"Table_productName__MjnJH"};